// extracted by mini-css-extract-plugin
export default {"container":"MarketingMaterials_container__Mta1d"};